import { IRootState } from '@/types/app';

const getters = {
  isLoading: (state: IRootState) => state.app.isLoading,
  sidebar: (state: IRootState) => state.app.sidebar,
  size: (state: IRootState) => state.app.size,
  device: (state: IRootState) => state.app.device,

  token: (state: IRootState) => state.auth.token,
  user: (state: IRootState) => state.auth.user,

  views: (state: IRootState) => state.tagsView.views,
};
export default getters;
